module.exports = __webpack_public_path__ + "9680d5a0c32d2fd084e07bbc4c8b2923.woff";